import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/Home.vue'
import AdminLogin from '../views/admin/Login.vue'
import AdminDashboard from '../views/admin/Dashboard.vue'
import KeyboardTool from '../views/KeyboardTool.vue'
import Agreement from '../views/Agreement.vue'
import Privacy from '../views/Privacy.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { hideNavigation: true }
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true, hideNavigation: true }
  },
  {
    path: '/keyboard-tool',
    name: 'KeyboardTool',
    component: KeyboardTool,
    meta: { hideNavigation: true }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: Agreement,
    meta: { hideNavigation: true }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: { hideNavigation: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 简单的路由守卫，检查登录状态
router.beforeEach((to, from, next) => {
  // 如果页面需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否登录
    const isLoggedIn = localStorage.getItem('admin_token')
    if (!isLoggedIn) {
      // 未登录，重定向到登录页面
      next({ name: 'AdminLogin' })
    } else {
      // 已登录，允许访问
      next()
    }
  } else {
    // 页面不需要认证，直接访问
    next()
  }
})

export default router 